<template>
  <div class="appcontainer dashboard">
    <div class="appcontainer__header">
      <AppPageHeader></AppPageHeader>
    </div>

    <div class="appcontainer__content">
      <div class="dashboard__board">
        <p>欢迎登陆本系统</p>
      </div>
      <div class="dashboard__info">
      </div>
      <div class="dashboard__divider">
          <el-divider class="divider"></el-divider>
      </div>
      <div class="dashboard__entrance">
          <div class="dashboard__entrance__title">快速入口</div>
          <div class="dashboard__entrance__content">
              <el-button type="primary" @click="$router.push('/schedulingstart')">开始排课</el-button>
          </div>          
      </div>
      <div class="dashboard__divider" v-if="isAdmin">
          <TodayScheWidget ></TodayScheWidget>
      </div>

    </div>


  </div>
</template>


<script>

import TodayScheWidget from "@/views/components/dashboard/TodayScheWidget.vue"

export default {
  name: "dashboard",
  components : {
    TodayScheWidget
  },
  data() {
    return {
      isAdmin : false
     
    }
  },
  mounted(){
    this.isAdmin = this.$store.getters['profileModule/isadmin'];
  }


}
</script>




<style scoped>
</style>

